import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { useWebmaster } from "context/admin/webmaster";

import ModalMobile from "components/ModalMobile";
import Button from "components/Button";
import Select from "components/form/Select";

import task_status_data from "libs/task_status_data.json";
import task_priority_data from "libs/task_priority_data.json";

const mainClass = "webmasters-admin-details__modal-filters";
const initialFilters = { priority: null, status: null };
const excludedStatuses = ["client_verification", "closed", "canceled"];

const ModalFilters = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { filters, applyFilters, filterClearAll } = useWebmaster();
  const [filtersInner, setFiltersInner] = useState(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState(initialFilters);

  useEffect(() => {
    const className = "webmasters-admin-details-modal-filters-open";
    document.body.classList.toggle(className, isOpen);
    return () => document.body.classList.remove(className);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setFiltersInner(initialFilters);
      setAppliedFilters(initialFilters);
      return;
    }

    const priorityFilters = filters?.priority?.split(",");
    const statusFilters = filters?.status?.split(",");
    const snapshot = {
      priority:
        priorityFilters?.length > 0
          ? task_priority_data?.find(
              (item) => item?.key === priorityFilters[0],
            ) || null
          : null,
      status:
        statusFilters?.length > 0
          ? task_status_data?.find((item) => item?.key === statusFilters[0]) ||
            null
          : null,
    };

    setAppliedFilters(snapshot);
    setFiltersInner(snapshot);
  }, [filters, isOpen]);

  const isDirty = useMemo(
    () =>
      filtersInner.priority?.key !== appliedFilters.priority?.key ||
      filtersInner.status?.key !== appliedFilters.status?.key,
    [filtersInner, appliedFilters],
  );

  return (
    <ModalMobile hasMobileScrollTop={false} isOpen={isOpen} onClose={onClose}>
      <div className={mainClass}>
        <div className={`${mainClass}__content`}>
          <div className={`${mainClass}__content-item`}>
            <Select.Priority
              selected={filtersInner.priority}
              forceBottom
              onChange={(option) =>
                setFiltersInner({ ...filtersInner, priority: option })
              }
            />
          </div>
          <div className={`${mainClass}__content-item`}>
            <Select.Status
              selected={filtersInner.status}
              optionFilters={excludedStatuses}
              onChange={(option) =>
                setFiltersInner({ ...filtersInner, status: option })
              }
            />
          </div>
        </div>
        <div className={`${mainClass}__actions`}>
          <Button
            disabled={Object.values(filtersInner).every((value) => !value)}
            onClick={() => {
              filterClearAll();
              setFiltersInner(initialFilters);
              setAppliedFilters(initialFilters);
            }}
          >
            {t("Remove filters")}
          </Button>
          <Button
            disabled={!isDirty}
            onClick={() => {
              applyFilters(filtersInner);
              onClose();
            }}
          >
            {t("Apply filters")}
          </Button>
        </div>
      </div>
    </ModalMobile>
  );
};

export default ModalFilters;